import api from "@/api/api-v2-config";

export async function getEventListAxios() {    
    return await api.get("hrms/events?pageNumber=1&pageSize=1000");
}

export async function deleteEventAxios(id) {    
    return await api.delete("hrms/events?EventId=" + id);
}

export async function postEventAxios(event) {    
    return await api.post("hrms/events", event);
}

export async function putEventAxios(event) {    
    return await api.put("hrms/events", event);
}

export async function getEventByIdAxios(id) {    
    return await api.get("hrms/eventbyid?EventId=" + id);
}